export default {
  getShippingAddress: ({
    cardholderAddress,
    organizationAddress,
    otherAddress,
    shippingDestination,
  }) => {
    switch (shippingDestination) {
      case 'cardholder_home':
        return cardholderAddress;
      case 'office':
        return organizationAddress;
      case 'other':
        return otherAddress;
    }
  },
};
